import { render, staticRenderFns } from "./newSalvageParts.vue?vue&type=template&id=d2a303b2&scoped=true"
import script from "./newSalvageParts.vue?vue&type=script&lang=js"
export * from "./newSalvageParts.vue?vue&type=script&lang=js"
import style0 from "./newSalvageParts.vue?vue&type=style&index=0&id=d2a303b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a303b2",
  null
  
)

export default component.exports